export default __webpack_public_path__ + "static/media/my-wheelbox.61318cf9.png";